import { render, staticRenderFns } from "./PlantStyle.vue?vue&type=template&id=0be92dd6&"
import script from "./PlantStyle.vue?vue&type=script&lang=js&"
export * from "./PlantStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports